import {RecordForm} from '../forms/RecordForm';


import {useTopLevelDomain} from '../hooks/useTopLevelDomain';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = useTopLevelDomain();

    return (
        <FormPageLayout
            title='Add Top Level Domain'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
